import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Ticket from "../../components/Ticket";

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		height: "100%",
		overflowY: "hidden",
	},
	chatPapper: {
		display: "flex",
		height: "100%",
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
	},
	contactsWrapperSmall: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		overflowY: "hidden",
		[theme.breakpoints.down("sm")]: {
			display: "none",
		},
	},
	messagessWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
	},
}));

/**
 * Layout legado (MUI Grid 4/8). Lista e Ticket são os mesmos componentes de produção.
 */
export default function TicketsLegacyShell({ ticketId, listPanel, welcomePanel }) {
	const classes = useStyles();

	return (
		<div className={classes.chatContainer}>
			<div className={classes.chatPapper}>
				<Grid container spacing={0}>
					<Grid
						item
						xs={12}
						md={4}
						className={
							ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
						}
					>
						{listPanel}
					</Grid>
					<Grid item xs={12} md={8} className={classes.messagessWrapper}>
						{ticketId ? <Ticket /> : welcomePanel}
					</Grid>
				</Grid>
			</div>
		</div>
	);
}
